<template>
    <div class="continer">
        <background>
            <div v-if="!isTakePhotoSuccess" class="identify-block">
                <div class="external-block"></div>
                <img  ref="camera" class="image-block" src="@/assets/images/busImage/people.png">
            </div>
            <div v-else class="identify-block">
                <div class="external-block" :class="result.status === 2? 'external-block-error' : ''"></div>
                <img class="image-block" :src="photo_color">
                <img @click="retryTakePhoto" v-if="result.status === 2" class="identify-error" src="@/assets/images/busImage/error.png">
            </div>
            <div class="tips">
                <div class="tips-info">{{result.tipsText}}</div>
                <div class="tips-list">
                    <div class="item" v-for="(item,index) in tipsList" :key="index">
                        <img class="item-icon" :src="item.icon"/>
                        <div class="item-text">{{item.text}}</div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <div class="other-login" @click="otherLogin">账号/密码登录</div>
                <div v-if="result.status === 2" class="retry-btn" @click="retryTakePhoto">重新人脸识别</div>
            </div>
        </background>
        
    </div>
</template>

<script>
import background from '@/components/background'
import { faceLogin } from '@/api/user'
export default {
    components: {
        background
    },
    data(){
        return{
            isTakePhotoSuccess: false,
            photo_color:"",
            photo_base64:"",
            photo_infrared:"",
            result: {
                status:0, // 0:识别中，1：成功 2：失败
                tipsText: '正在进行人脸识别',
            },
            tipsList: [
                {   
                    icon: require('@/assets/images/busImage/eye.png'),
                    text:'避免遮挡'
                },
                {
                    icon: require('@/assets/images/busImage/light.png'),
                    text:'光线充足'
                },
                {
                    icon: require('@/assets/images/busImage/phone.png'),
                    text:'正对屏幕'
                }
            ]
        }
    },
    mounted(){
        setTimeout(() => {
            this.startCamera()
        },500)
        
    },
    beforeDestroy(){
        this.closePage()
    },
    methods: {
        // 开启摄像头
        async startCamera(){
            const camera = this.$refs.camera;
            this.cam.attachElement(camera);
            var param = {};
            param.show_type = 1;		//0 1 2
            //param.x=100;
            //param.y=100;
            //param.w=640;
            //param.h=480;
            var result = await this.cam.startCamera(param);
            console.info(JSON.stringify(result));
            if(result.result==0){
                console.info("开启摄像头成功");
                this.liveCapture()
            }else{
                console.error("开启发生错误:"+result.message);
            }
        },
        
        // 活体检测
        async liveCapture(){
            var param ={};
            param.action = "live_capture";
            param.face_image = true;
            param.infrared_face_image = true;
            var result = await this.cam.capture(param);
            // console.info(JSON.stringify(result));
            if(result.result==0){
                this.isTakePhotoSuccess = true
                this.photo_color = "data:image/jpeg;base64,"+result.face_image_base64;
                console.info(this.photo_color);
                this.photo_base64 = result.face_image_base64;
                this.photo_infrared = "data:image/jpeg;base64,"+result.infrared_face_image_base64;
                this.closePage()
                this.uploagFace(this.photo_base64)
            }else{
                console.error("拍照发生错误:"+result.message);
            }
        },
        uploagFace(photoImage){
            faceLogin({face:photoImage}).then(res => {
                console.log(res)
                if(res.data.code == 200){
                    // 人脸识别成功，跳转
                    this.result.status = 1
                    this.result.tipsText = '人脸识别成功'
                    this.$store.dispatch('FaceLogin',res.data).then(() => {
                        this.$router.push({name: 'start'})
                    })
                }else {
                    // 人脸识别错误
                    this.result.status = 2
                    this.result.tipsText = res.data.msg || '人脸识别失败'
                } 
            }).catch(e => {
                this.result.status = 2
                this.result.tipsText = res.data.msg || '人脸识别失败'
            })
        },
        // 关闭页面
        closePage(){
            this.cancelPhotos().then(res => {
                this.stopCamera().then(res => {
                })
            })
        },
        // 取消拍照
        cancelPhotos(){
            return new Promise( async(reslove,reject) => {
                var result = await this.cam.cancel();
                console.info(JSON.stringify(result));
                if(result.result==0){
                    console.info("取消成功");
                    reslove()
                }else{
                    console.error("取消发生错误:"+result.message);
                    reject()
                }
            })
        },
        // 关闭摄像头
        async stopCamera(){
            return new Promise(async (reslove,reject) => {
                var result = await this.cam.stopCamera();
                    console.info(JSON.stringify(result));
                if(result.result==0){
                    console.info("关闭摄像头成功");
                    reslove()
                }else{
                    console.error("关闭发生错误:"+result.message);
                    reject()
                }
            })
        },
        retryTakePhoto(){
            this.isTakePhotoSuccess = false
            this.result =  {
                status:0, // 0:识别中，1：成功 2：失败
                tipsText: '正在进行人脸识别',
            }
            this.photo_color = ''
            setTimeout(() => {
                this.startCamera()
            },500)
        },
        otherLogin(){
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .identify-block {
        position: relative;
        width: 457px;
        height: 441px;
        margin: 91px auto 0 auto;
        .external-block {
            width: 457px;
            height: 457px;
            overflow: hidden;
            border-radius: 50%;
            background: linear-gradient(to bottom, #F7636E 50%,  rgba(247,99,110,0.2) 50%);
            animation: rotate 3s linear infinite;
        }
        .external-block-error {
            background: #F7636E;
        }
        @keyframes rotate {
            from {
            transform: rotate(0deg);
            }
            to {
            transform: rotate(360deg);
            }
        }
        .image-block {
            width: 441px;
            height: 441px;
            border-radius: 50%;
            position: absolute;
            top:8px;
            left: 8px;
            background-image: url(~@/assets/images/busImage/people.png);
            background-size: 115%; /* 背景图片覆盖整个元素 */
            background-repeat: no-repeat; /* 背景图片不重复 */
            background-position: center; /* 背景图片居中 */
        }
        .identify-error {
            position: absolute;
            top: 300px;
            right: 0;
        }
    }
    .tips {
        width: 594px;
        margin: 48px auto 0 auto;
        &-info {
            font-weight: 400;
            font-size: 48px;
            text-align: center;
            margin-bottom: 48px;
            color: rgba(0,0,0,0.85);
            line-height: 67px;
            letter-spacing: 17px;
        }
        &-list {
            display: flex;
            justify-content:space-around;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                &-icon {
                    width: 53px;
                    height: 53px;
                    margin-bottom: 11px;
                }
                &-text {
                    font-weight: 400;
                    font-size: 17px;
                    text-align: center;
                    color: rgba(0,0,0,0.45);
                    line-height: 24px;
                }
            }
        }
    }
    .btn-group {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 352px;
        right: 30px;
        .other-login {
            width: 263px;
            height: 80px;
            line-height: 80px;
            margin-bottom: 32px;
            background: #FFEEF1;
            border-radius: 8px 0px 0px 8px;
            font-weight: 600;
            font-size: 28px;
            text-align: center;
            color: #F7636E;
        }
        .retry-btn {
            width: 263px;
            height: 80px;
            line-height: 80px;
            background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
            border-radius: 8px 0px 0px 8px;
            font-weight: 600;
            font-size: 28px;
            text-align: center;
            color: #fff;
        }
    }
</style>


